import Controller from '@ember/controller';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import { task, timeout } from 'ember-concurrency';

import { query } from 'umg-ember-backend/data/builders/umg-rest';

class MergeArtistsSettings {
  id = 0;
  recordType = 'tool-merge-artists';
  @tracked sources = [];
  @tracked target = null;

  toJSON() {
    return {
      sources: this.sources.map((model) => model.id),
      target: this.target.id,
    };
  }

  reset() {
    this.sources = [];
    this.target = null;
  }
}

export default class AdminArtistMergeArtists extends Controller {
  // Services
  @service fetch;
  @service flashMessages;
  @service headData;
  @service intl;
  @service store;

  // Defaults
  mergeArtistSettings = new MergeArtistsSettings();

  // Getter, setter and computed properties
  get notReady() {
    return !(
      this.mergeArtistSettings.target && this.mergeArtistSettings.sources
    );
  }

  // Actions
  onChangeSources = (options) => {
    this.mergeArtistSettings.sources = options;
  };

  setHeadData = () => {
    this.headData.title = this.intl.t('tool_merge_artists.headline');
    this.headData.favicon = this.mergeArtistSettings.recordType;
  };

  // Tasks
  searchArtists = task({ restartable: true }, async (term) => {
    await timeout(1000);

    const { content } = await this.store.request(
      query('artist', {
        'search[value]': term,
        'search[mode]': 'contains',
        'limit': 50,
      }),
    );

    return content.data ?? [];
  });

  mergeArtists = task(async () => {
    try {
      const response = await this.fetch.post('/tools/mergeArtist', {
        data: this.mergeArtistSettings.toJSON(),
      });

      await this.store.push(this.store.normalize('artist', response.artist));

      this.mergeArtistSettings.reset();
      this.flashMessages.success('tool_merge_artists.merged');
    } catch (error) {
      const message = error.payload?.errors?.message ?? error;
      this.flashMessages.error(message, {
        rawString: true,
      });
    }
  });
}
